import { BaseError } from 'viem'

import { ActionHandlerState } from './types'
import { aaveContractErrors } from '@/config/aaveContractErrors'
import { PreWriteCheckError } from '@/domain/errors/PreWriteCheckError'
import type { UseRegularOrEip5792WriteResult } from '@/features/actions/logic/transactions/useRegularOrEip5792Write'

export function mapWriteResultToActionState(result: UseRegularOrEip5792WriteResult): ActionHandlerState {
  switch (result.status.kind) {
    case 'ready':
      return { status: 'ready' }

    case 'disabled':
      return { status: 'disabled' }

    case 'simulating':
    case 'wallet-type-pending':
    case 'tx-mining':
    case 'tx-sending':
      return { status: 'loading' as const }

    case 'error':
      return {
        status: 'error',
        errorKind: result.status.errorKind,
        message: parseWriteErrorMessage(result.status.error),
      }

    case 'success':
      return { status: 'success' }
  }
}

export function parseWriteErrorMessage(
  error: Error | undefined,
  { isBatchWrite }: { isBatchWrite?: boolean } = {},
): string {
  if (error instanceof PreWriteCheckError) {
    return parseWriteErrorMessage(error.originalError, { isBatchWrite })
  }
  if (error instanceof BaseError) {
    return decodeRevertReason(isBatchWrite ? error.details : error.shortMessage)
  }
  if (error instanceof Error) {
    return error.message
  }
  return 'Unknown error'
}

function decodeRevertReason(errorMessage: string): string {
  const aaveRevertReason = errorMessage.match(/reverted with the following reason:\s*(\d+)/)?.[1]

  if (aaveRevertReason) {
    if (aaveContractErrors[aaveRevertReason]) {
      return aaveContractErrors[aaveRevertReason]
    }
  }

  if (errorMessage.endsWith('reverted with the following reason:\nExchange resulted in fewer coins than expected')) {
    return 'Exchange resulted in fewer coins than expected. You might need to adjust your slippage.'
  }

  return errorMessage
}
